import Types from "./Types";

// Get all live videos
export const getAllLiveVideosRequest = () => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_REQUEST,
});

export const getAllLiveVideosSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_SUCCESS,
  payload: data,
});

export const getAllLiveVideosFail = () => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_FAIL,
});

// Get live video by ID
export const getLiveVideoByIdRequest = (id) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEO_BY_ID_REQUEST,
  payload: id,
});

export const getLiveVideoByIdSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEO_BY_ID_SUCCESS,
  payload: data,
});

export const getLiveVideoByIdFail = () => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEO_BY_ID_FAIL,
});

// Create live video
export const createLiveVideoRequest = (data, action) => ({
  type: Types.CREATE_SUPERADMIN_LIVE_VIDEO_REQUEST,
  payload: data,
  action: action,
});

export const createLiveVideoSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_LIVE_VIDEO_SUCCESS,
  payload: { data },
});

export const createLiveVideoFail = () => ({
  type: Types.CREATE_SUPERADMIN_LIVE_VIDEO_FAIL,
});

// Update live video
export const updateLiveVideoRequest = (id, data, action) => ({
  type: Types.UPDATE_SUPERADMIN_LIVE_VIDEO_REQUEST,
  payload: { id, data, action },
});

export const updateLiveVideoSuccess = ({ data }) => ({
  type: Types.UPDATE_SUPERADMIN_LIVE_VIDEO_SUCCESS,
  payload: { data },
});

export const updateLiveVideoFail = () => ({
  type: Types.UPDATE_SUPERADMIN_LIVE_VIDEO_FAIL,
});

// Delete live video
export const deleteLiveVideoRequest = (id, action) => ({
  type: Types.DELETE_SUPERADMIN_LIVE_VIDEO_REQUEST,
  payload: { id, action },
});

export const deleteLiveVideoSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_LIVE_VIDEO_SUCCESS,
  payload: id,
});

export const deleteLiveVideoFail = () => ({
  type: Types.DELETE_SUPERADMIN_LIVE_VIDEO_FAIL,
});

// Get live videos by course
export const getLiveVideosByCourseRequest = (courseId) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_REQUEST,
  payload: courseId,
});

export const getLiveVideosByCourseSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_SUCCESS,
  payload: data,
});

export const getLiveVideosByCourseFail = () => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_FAIL,
});

// Get live videos by teacher
export const getLiveVideosByTeacherRequest = (teacherId) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_REQUEST,
  payload: teacherId,
});

export const getLiveVideosByTeacherSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_SUCCESS,
  payload: data,
});

export const getLiveVideosByTeacherFail = () => ({
  type: Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_FAIL,
});

// Loading state
export const liveVideosLoading = (isLoading) => ({
  type: Types.SUPERADMIN_LIVE_VIDEOS_LOADING,
  payload: isLoading,
}); 